/**
 * Configuration for the app.
 */
const jobiqoAppConfig = require('./../../src/jobiqo/config/app');
const mergeDeepRight = require('ramda/src/mergeDeepRight');

const defaultLocale = 'en';
const defaultRegion = 'eu';
const locales = ['en'];

const priceConfig = {
  CURRENCY_PLACEMENT: 'before',
  USE_SPACING: false,
};

module.exports = mergeDeepRight(jobiqoAppConfig, {
  public: {
    TURBOPACK_BUILD: true,
    EURO_VAT_SYSTEM: false,
    SITENAME: 'Keene Sentinel',
    SITE_DESCRIPTION:
      'Find local jobs in Keene, NH area. New full time and part time jobs are posted every day. The Keene Sentinel',
    OG_IMAGE: '/static/keenesentinel/keenesentinel_logo.png',
    DEFAULT_LOCALE: defaultLocale,
    DEFAULT_REGION: defaultRegion,
    LOCALES: locales,
    SOCIAL_LINKS: {
      facebook: 'https://www.facebook.com/thekeenesentinel/',
      twitter: ' https://twitter.com/Keene_Sentinel',
      instagram: 'https://www.instagram.com/keene_sentinel/',
    },
    ASSETS: {
      logo: '/static/keenesentinel/keenesentinel_logo.png',
    },
    AUTOCOMPLETE_WIDGET_OPTIONS: {
      country: ['us', 'ca'],
    },
    THEME: {
      colors: {
        primary: '#97bd45',
      },
    },
    LINKEDIN_OAUTH_FEATURE_ACTIVE: false,
    FACEBOOK_OAUTH_FEATURE_ACTIVE: false,
    GOOGLE_OAUTH_FEATURE_ACTIVE: false,
    GA4_MEASUREMENT_IDS: ['G-VP3C1F2GK8', 'G-04SBN34ERZ'],
    BLOG_FEATURE_ACTIVE: true,
    PRICE_CONFIG: priceConfig,
  },
});
